import React, { useState, useEffect, useRef } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  FeatureGroup,
  Polyline,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { EditControl } from "react-leaflet-draw";
import axios from "axios";
import cordinations from "./data/codinaties";

export default function ModalMap() {
  useEffect(() => {
    // Any initialization logic can go here
  }, []);

  const [showModalMain, setShowModalMain] = useState(false);
  const mapRef = useRef(null);

  const handleClose = () => setShowModalMain(false);
  const handleMarkerClick = (event) => {
    setShowModalMain(true);
    const map = event.target._map;
    map.flyTo(event.latlng, 12);
  };

  const handleResetMap = () => {
    if (mapRef.current) {
      const map = mapRef.current;
      map.setView([41.3775, 64.5853], 6.4);
    }
  };

  const customIcon = L.icon({
    iconUrl: "https://img.icons8.com/ultraviolet/40/000000/marker.png",
    iconSize: [30, 35],
    iconAnchor: [12, 41],
    popupAnchor: [0, -41],
  });

  return (
    <>
      <button
        className="btn btn-green uppercase text-center m-auto rounded-lg text-white mt-10"
        style={{
          width: "200px",
          height: "50px",
          backgroundColor: "rgba(0, 164, 146, 1)",
          fontSize: "20px",
          fontWeight: "600",
        }}
        onClick={() => setShowModalMain(true)}
      >
        link
      </button>
      {showModalMain && (
        <>
          <div
            className="fixed inset-0 z-40 bg-black bg-opacity-50 transition-opacity"
            onClick={handleClose}
          />
          <div className="fixed inset-0 z-50 flex justify-center items-center">
            <div
              className="relative bg-white rounded-lg shadow-lg overflow-hidden"
              style={{ width: "90%", height: "90%" }}
            >
              <button
                className="absolute top-2 right-2 text-black"
                onClick={handleClose}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: "24px",
                  cursor: "pointer",
                }}
              >
                &times;
              </button>
              <div
                style={{
                  padding: "20px",
                  height: "100%",
                  boxSizing: "border-box",
                }}
              >
                <h1 style={{ marginBottom: "20px", fontSize: "15px" }}>
                  МАГИСТРАЛ ЙЎЛЛАР БЎЙИДА ДАВЛАТ-ХУСУСИЙ ШЕРИКЛИК АСОСИДА ТАШКИЛ
                  <br />
                  ЭТИЛАДИГАН ХИЗМАТ КЎРСАТИШ ВА СЕРВИС МАРКАЗЛАРИ
                </h1>
                <div style={{ height: "calc(100% - 60px)" }}>
                  <MapContainer
                    ref={mapRef}
                    center={[41.3775, 64.5853]}
                    zoom={6.4}
                    scrollWheelZoom={false}
                    style={{ height: "100%", width: "100%" }}
                  >
                    <TileLayer
                      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    {cordinations.map((e, index) => (
                      <Polyline
                        key={index}
                        positions={e.data.map((element) => [
                          element.lat,
                          element.lon,
                        ])}
                        color={e.color}
                        weight={5}
                        opacity={1}
                      />
                    ))}
                    <FeatureGroup>
                      <EditControl
                        position="topright"
                        draw={{
                          rectangle: false,
                          polygon: false,
                          circle: false,
                          circlemarker: false,
                        }}
                      />
                    </FeatureGroup>
                    {cordinations.map((e) =>
                      e.data.map((element) => (
                        <Marker
                          key={element.name}
                          position={[element.lat, element.lon]}
                          eventHandlers={{
                            click: (event) => handleMarkerClick(event),
                          }}
                          icon={customIcon}
                        ></Marker>
                      ))
                    )}
                  </MapContainer>
                </div>
                <button
                  onClick={handleResetMap}
                  style={{
                    position: "absolute",
                    bottom: "20px",
                    left: "20px",
                    zIndex: "1000",
                    backgroundColor:'white',
                    padding:'10px',
                    margin:'10px',
                    borderRadius:'    px',
                    fontSize:"15px",
                    fontWeight:'600'
                  }}
                >
                  HOME
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
